import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';

export default () => {
  domContentLoaded(() => {
    //アコーディオンをクリックした時の動作
    $('.js_accordion').on('click', function () {
      const $nextAccordion = $(this).next('.js_accordion_open');
      $nextAccordion.slideToggle();

      if ($(this).hasClass('close')) { // タイトル要素にクラス名closeがあれば
        $(this).removeClass('close');// クラス名を除去し
      } else { // それ以外は
        $(this).addClass('close');// クラス名closeを付与
      }
    });
  });
};